import { ReactComponent as IconSvg } from 'approot/shared/inline-svg/activity-builder/icon_border_widths.svg';
import Icon, { IconProps } from '../../icons/icon';

const IconBorderWidths = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconBorderWidths;
